<table
  class="table-value-recognition"
  [class.urgency-x-vulnerability]="isUrgencyXVulnerability"
>
  <thead>
    <tr class="table-title">
      <td [attr.colspan]="isUrgencyXVulnerability ? 5 : 4">{{ title }}</td>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="isUrgencyXVulnerability">
      <td class="vulnerability-title" colspan="5">vulnerability</td>
    </tr>
    <tr class="sub-title">
      <td *ngIf="isUrgencyXVulnerability" class="urgency-title" rowSpan="4">
        {{ isUrgencyXVulnerability ? "urgency" : "" }}
      </td>
      <td></td>
      <td *ngFor="let columnTitle of tableInfo.columnsTitle">
        <ng-container *ngIf="columnTitle; else emptyCell">
          {{ columnTitle }}
        </ng-container>
        <ng-template #emptyCell> &nbsp; </ng-template>
      </td>
    </tr>
    <tr *ngFor="let rowTitle of tableInfo.rowsTitle; index as rowIndex">
      <td class="sub-title">{{ rowTitle }}</td>
      <td
        *ngFor="let columnTitle of tableInfo.columnsTitle; index as columnIndex"
      >
        <input
          id="deliverableKeywords"
          name="deliverableKeywords"
          type="text"
          class="adap-form-input"
          [readonly]="readonly"
          [ngrxFormControlState]="
            tableInfo.formControlState[rowIndex][columnIndex]
          "
        />
      </td>
    </tr>
  </tbody>
</table>
